import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import GridOnIcon from '@mui/icons-material/GridOn';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import ImageIcon from '@mui/icons-material/Image';
import MovieIcon from '@mui/icons-material/Movie';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import CodeIcon from '@mui/icons-material/Code';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

// Map a file extension → MUI icon component + brand-ish color.
const MAP = {
    pdf: { Icon: PictureAsPdfIcon, color: '#d32f2f' },
    doc: { Icon: DescriptionIcon, color: '#1565c0' },
    docx: { Icon: DescriptionIcon, color: '#1565c0' },
    txt: { Icon: DescriptionIcon, color: '#607d8b' },
    rtf: { Icon: DescriptionIcon, color: '#607d8b' },
    xls: { Icon: GridOnIcon, color: '#2e7d32' },
    xlsx: { Icon: GridOnIcon, color: '#2e7d32' },
    csv: { Icon: GridOnIcon, color: '#2e7d32' },
    ppt: { Icon: SlideshowIcon, color: '#e64a19' },
    pptx: { Icon: SlideshowIcon, color: '#e64a19' },
    zip: { Icon: FolderZipIcon, color: '#795548' },
    rar: { Icon: FolderZipIcon, color: '#795548' },
    '7z': { Icon: FolderZipIcon, color: '#795548' },
    gz: { Icon: FolderZipIcon, color: '#795548' },
    png: { Icon: ImageIcon, color: '#0288d1' },
    jpg: { Icon: ImageIcon, color: '#0288d1' },
    jpeg: { Icon: ImageIcon, color: '#0288d1' },
    gif: { Icon: ImageIcon, color: '#0288d1' },
    webp: { Icon: ImageIcon, color: '#0288d1' },
    svg: { Icon: ImageIcon, color: '#0288d1' },
    mp4: { Icon: MovieIcon, color: '#6a1b9a' },
    mov: { Icon: MovieIcon, color: '#6a1b9a' },
    avi: { Icon: MovieIcon, color: '#6a1b9a' },
    mkv: { Icon: MovieIcon, color: '#6a1b9a' },
    webm: { Icon: MovieIcon, color: '#6a1b9a' },
    mp3: { Icon: AudiotrackIcon, color: '#00897b' },
    wav: { Icon: AudiotrackIcon, color: '#00897b' },
    m4a: { Icon: AudiotrackIcon, color: '#00897b' },
    js: { Icon: CodeIcon, color: '#f9a825' },
    json: { Icon: CodeIcon, color: '#f9a825' },
    html: { Icon: CodeIcon, color: '#f9a825' },
    css: { Icon: CodeIcon, color: '#f9a825' },
};

export function getFileMeta(extOrName = '') {
    let ext = String(extOrName).toLowerCase();
    if (ext.includes('.')) ext = ext.split('.').pop();
    return MAP[ext] || { Icon: InsertDriveFileIcon, color: '#9e9e9e' };
}

export function formatFileSize(bytes = 0) {
    if (!bytes) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0)} ${units[i]}`;
}

export default getFileMeta;
